import { AudioFile } from '@bnnvara/icons/src/components/UserInterfaceIcons/AudioFile';
import { Download } from '@bnnvara/icons/src/components/UserInterfaceIcons/Download';
import { TextFile } from '@bnnvara/icons/src/components/UserInterfaceIcons/TextFile';
import PropTypes from 'prop-types';
import React from 'react';
import * as S from './styled';

const DownloadButton = ({
  fileUrl,
  fileName,
  fileType,
  onClick
}) => {
  const FileTypeIcon = ['mp3', 'wav'].includes(fileType) ? AudioFile : TextFile;
  return /*#__PURE__*/React.createElement("a", {
    href: fileUrl,
    target: "_blank",
    rel: "noopener noreferrer",
    download: true
  }, /*#__PURE__*/React.createElement(S.StyledButton, {
    onClick: onClick
  }, /*#__PURE__*/React.createElement(S.FileBoxLeft, {
    "data-filetype": `.${fileType}`
  }, /*#__PURE__*/React.createElement(FileTypeIcon, null), /*#__PURE__*/React.createElement(S.FileName, null, fileName)), /*#__PURE__*/React.createElement(S.IconBoxRight, null, /*#__PURE__*/React.createElement(Download, null))));
};

DownloadButton.defaultProps = {
  onClick: null
};
DownloadButton.propTypes = {
  fileName: PropTypes.string.isRequired,
  fileUrl: PropTypes.string.isRequired,
  fileType: PropTypes.string.isRequired,
  onClick: PropTypes.node
};
export default DownloadButton;